module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft-4-d4abfcd5cf4cb7e9e11c02cdbe0bd329.png";